import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';import { connect } from 'react-redux';
import { CommonButton } from '../../../../../components/buttons';
import DownloadTargetForRawData from './DownloadTargetForRawDataModal';
import DownloadBehaviorsForRawDataModal from './DownloadBehaviorsForRawDataModal';


class DownloadTargetBehaviors extends Component {
    constructor(props) {
        super(props);
        this.state={
          openDownloadTargetRawData:false,
          openDownloadBehaviorsForRawDataModal:false,
        }
    }

    openDownloadTargetRawDataFunction = () => {
        this.setState({openDownloadTargetRawData: true})
    }
    closeDownloadTargetRawDataFunction = () => {
        this.setState({openDownloadTargetRawData: false})
    }

    openDownloadBehaviorsForRawDataModalHandler = () => {
        this.setState({openDownloadBehaviorsForRawDataModal:true})
    }

    closeDownloadBehaviorsForRawDataModalHandler = () => {
        this.setState({openDownloadBehaviorsForRawDataModal:false})
    }


    render(){
        return (
            <div className="row">
                <div className="panel_title">
                    <em>*Please use the downloaded file as a template to upload raw data for Targets or Behaviors</em>
                </div>

                <div className="col-sm-12">
                    {this.state.openDownloadTargetRawData ?
                        <DownloadTargetForRawData
                            closeDialog={this.closeDownloadTargetRawDataFunction}
                        /> :
                        null
                    }
                    <CommonButton className="mt-10" label="DOWNLOAD TARGETS FOR RAW DATA" primary={true} onTouchTap={this.openDownloadTargetRawDataFunction} />
                </div>
                <div>
                    {this.state.openDownloadBehaviorsForRawDataModal?
                        <DownloadBehaviorsForRawDataModal
                        closeDialog={this.closeDownloadBehaviorsForRawDataModalHandler}
                        /> : null
                    }
                    <CommonButton className="mt-10" label="DOWNLOAD BEHAVIORS FOR RAW DATA" primary={true} onTouchTap={this.openDownloadBehaviorsForRawDataModalHandler} />
                </div>
            </div>
        )
    }
}

export default DownloadTargetBehaviors;


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargetsBehaviors/index.js